const urlPattern = /(https?:\/\/|www\.)[^\s]+/i;

export default {
	hasNoUrl(value, fieldName, displayName, errors) {
		if (typeof value === 'string' && urlPattern.test(value)) {
			errors[fieldName] = `${displayName} cannot contain a URL.`;
			return false;
		}
		return true;
	},

	isRequired(value, fieldName, displayName, errors) {
		if (value === undefined || value === null || value === '') {
			errors[fieldName] = `${displayName} is required.`;
			return false;
		}
		return true;
	},

	validateField({ value, field, label, required }, errors) {
		if (required && !this.isRequired(value, field, label, errors)) return false;
		return this.hasNoUrl(value, field, label, errors);
	},

	validateForm(fields, errors) {
		let isValid = true;

		for (const field of fields) {
			if (!this.validateField(field, errors)) isValid = false;
		}

		return isValid;
	},
};